import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { ATTACHMENTS_TYPES } from '@ubeya/shared/constants';
import { ReactComponent as PDFIcon } from '@ubeya/shared-web/assets/file-pdf.svg';
import useArrayManagement from '@ubeya/shared-web/hooks/useArrayManagement';
import { getSource, getExtension } from '@ubeya/shared-web/utils/files';
import { FlexColumn } from '@ubeya/shared-web/components';
import EmployeeAttachment from './EmployeeAttachment';
import EmployeeDocumentPreview from './EmployeeDocumentPreview';

const attachment = css`
  width: 50px;
  height: 50px;
  border-radius: 8px;
  margin-top: 10px;
  &:not(:nth-child(4n)) {
    margin-right: 10px;
  }
`;

const Image = styled.div.attrs(({ src }) => ({ style: { backgroundImage: `url(${src})` } }))`
  width: 400px;
  height: 400px;
  border-radius: 3px;
  position: relative;
  cursor: ${({ enabled }) => (enabled ? 'pointer' : 'default')};

  &&& {
    background-image: url(${({ image }) => image});
    background-size: cover;
    background-position: center;
  }
  text-align: center;
  outline: none;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

const Video = styled.video.attrs(() => ({ controls: true }))`
  ${attachment};
  object-fit: cover;
  &:hover {
    cursor: pointer;
  }
`;

const Wrapper = styled(FlexColumn)`
  overflow: auto;

  .actions {
    padding: 0;
    margin: 10px 0;
  }

  .attachment-container {
    padding: 0;
    margin: 0 0 10px 0;
  }
`;

const getAttachmentComponent = (type) => {
  switch (type) {
    case 'document':
      return EmployeeDocumentPreview;
    case 'image':
      return Image;
    case 'video':
      return Video;
    default:
      return EmployeeDocumentPreview;
  }
};

const AttachmentsEmployeeField = ({ dataName }) => {
  const { data, handleAddItems, handleDelete } = useArrayManagement(dataName);

  const attachments = useMemo(
    () =>
      data.map((item) => {
        const extension = getExtension(item).toLowerCase();
        const type = ATTACHMENTS_TYPES[extension];

        return {
          id: item.id,
          src: getSource(item),
          Component: getAttachmentComponent(type),
          name: type === 'document' && extension,
          extension,
          type,
          title: item?.title,
          icon: type === 'document' && PDFIcon
        };
      }),
    [data]
  );

  return (
    <Wrapper>
      <EmployeeAttachment
        data={attachments}
        handleDeleteItems={handleDelete}
        handleAddItems={handleAddItems}
        singleFile
      />
    </Wrapper>
  );
};

export default AttachmentsEmployeeField;
